import React from "react";
import ServerErrorPageComponent from "./serverErrorPage.component";

const ServerErrorPageContainer = () => {
  return <ServerErrorPageComponent />;
};

export default ServerErrorPageContainer;
